import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePagination } from '@shared/hooks/usePagination';

const Pagination = ({ pageNumber, totalPages, totalElements, pageSize, setpageNumber }) => {
    const { t } = useTranslation();
    const { handleNextPage, handlePrevPage, handlePageClick, getPageNumbers } = usePagination({
        pageNumber,
        setpageNumber,
        totalPages
    });

    return (
        <div className="pagination-container">
            <span className="page-info">
                {t('users.table.pagination.showing')} {pageNumber * pageSize + 1}{' '}
                {t('users.table.pagination.to')}{' '}
                {Math.min((pageNumber + 1) * pageSize, totalElements)}{' '}
                {t('users.table.pagination.of')} {totalElements}{' '}
                {t('users.table.pagination.entries')}
            </span>

            <nav aria-label="Page navigation">
                <ul className="pagination">
                    {/* Previous Button */}
                    <li className={`page-item ${pageNumber === 0 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={handlePrevPage}
                            disabled={pageNumber === 0}
                        >
                            {t('users.table.pagination.previous')}
                        </button>
                    </li>

                    {/* Page Numbers */}
                    {getPageNumbers().map((number, index) => (
                        <li
                            key={index}
                            className={`page-item ${number === '...' ? 'disabled' : ''} ${
                                pageNumber === number ? 'active' : ''
                            }`}
                        >
                            {number === '...' ? (
                                <span className="page-link">...</span>
                            ) : (
                                <button
                                    className="page-link"
                                    onClick={() => handlePageClick(number)}
                                >
                                    {number + 1}
                                </button>
                            )}
                        </li>
                    ))}

                    {/* Next Button */}
                    <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={handleNextPage}
                            disabled={pageNumber >= totalPages - 1}
                        >
                            {t('users.table.pagination.next')}
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Pagination;




